export const ehcExpert = [
  { value: "", name: "Select EHC Expert" },
  // { value: "expert33_dechen", name: "Dechen" },
  // { value: "expert27_preetha", name: "Preetha" },
  // { value: "expert34_shefali", name: "Shefali" },
  // { value: "expert38_sikha", name: "Sikha" },
  // { value: "expert48_sonia", name: "Sonia" },
  // { value: "expert39_rachel", name: "Rachel" },
  { value: "expert4_tamannarajpal", name: "User1" },
  { value: "expert_mahi", name: "User2" },
  { value: "expert_user3", name: "User3" },
  { value: "expert_navyav", name: "User4" },
  { value: "expert_prakriti", name: "Prakriti" },
  { value: "expert_jigyasa", name: "Jigyasa" },
  { value: "expert_tania", name: "Tania" },
  // { value: "expert53_sanjanabarot", name: "Sanjana Barot" },
  // { value: "expert56_hemanipanchal", name: "Hemani Panchal" },
  // { value: "expert66_aanchallakhotia", name: "Aanchal Lakhotia" },
  // { value: "expert47_tanuushree", name: "Tanushree Sarawagi" },
  // { value: "expert57_swati", name: "Swati" },
  // { value: "test_ayush", name: "Ayush Singh" },
];
